import { publicURL } from 'utils/axiosInstance';
import has24Checkin from '../assets/amenity-icons/has24Checkin.png';
import hasElevator from '../assets/amenity-icons/hasElevator.png';
import hasWasher from '../assets/amenity-icons/hasWasher.png';
import hasAirConditioning from '../assets/amenity-icons/hasAirConditioning.png';
import hasHotTub from '../assets/amenity-icons/hasHotTub.png';
import hasPool from '../assets/amenity-icons/hasPool.png';
import isFamilyFriendly from '../assets/amenity-icons/isFamilyFriendly.png';
import hasDoorman from '../assets/amenity-icons/hasDoorman.png';
import allowsPets from '../assets/amenity-icons/allowsPets.png';
import hasPrivateEntrance from '../assets/amenity-icons/hasPrivateEntrance.png';

export interface amenitiy {
  label: string;
  key: string;
  icon: string;
}

export interface amenitiyData {
  label: string;
  key: string;
  icon: string;
  status: boolean;
}

export const amenities = [
  { label: 'Square Footage', key: 'squareFootage', icon: `${publicURL}/images/icon-1.jpg` },
  { label: '24-hour check in', key: 'has24Checkin', icon: has24Checkin },
  { label: 'Doorman', key: 'hasDoorman', icon: hasDoorman },
  { label: 'Onsite parking', key: 'hasFreeParking', icon: `${publicURL}/images/icon-1.jpg` },
  { label: 'Elevator', key: 'hasElevator', icon: hasElevator },
  { label: 'Wheelchair accessible', key: 'isWheelchairAccessible', icon: `${publicURL}/images/icon-1.jpg` },
  { label: 'Private entrance', key: 'hasPrivateEntrance', icon: hasPrivateEntrance },
  { label: 'Family friendly', key: 'isFamilyFriendly', icon: isFamilyFriendly },
  { label: 'No kids', key: 'childrenNotAllowed', icon: `${publicURL}/images/icon-1.jpg` },
  { label: 'No infants', key: 'infantNotAllowed', icon: `${publicURL}/images/icon-1.jpg` },
  { label: 'Crib/child cot ', key: 'cribChildCot', icon: `${publicURL}/images/icon-1.jpg` },
  { label: 'Pet friendly', key: 'allowsPets', icon: allowsPets },
  { label: 'Event friendly', key: 'isEventFriendly', icon: `${publicURL}/images/icon-1.jpg` },
  { label: 'Washer', key: 'hasWasher', icon: hasWasher },
  { label: 'Dryer', key: 'hasDryer', icon: `${publicURL}/images/icon-1.jpg` },
  { label: 'Air conditioning', key: 'hasAirConditioning', icon: hasAirConditioning },
  { label: 'Hot tub', key: 'hasHotTub', icon: hasHotTub },
  { label: 'Pool', key: 'hasPool', icon: hasPool }
];
